'use client';
import { Spinner } from '@stone-payments/jade';
import { useParams } from 'next/navigation';
import { usePaymentLinkId } from '../../hooks/usePaymentLinkId';

import { Organizations } from '@payments-checkout/shared/helpers/index';
import { isValidPaymentLinkId } from '@payments-checkout/shared/helpers/validators/payment-link-validator';
import { isLegacyStoneLogo } from './legacyStoneLogo';
import { LogoStone } from './logoStone';
import { LogoTon } from './logoTon';

const fallbackLogo = (organization?: string) => {
  if (organization === 'ton') {
    return <LogoTon aria-label="logo-ton" role="img" />;
  }
  return <LogoStone aria-label="logo-stone" role="img" />;
};

export function HeaderLogo() {
  const params = useParams<{ paymentLinkId: string }>();

  if (!params?.paymentLinkId || !isValidPaymentLinkId(params.paymentLinkId)) {
    return fallbackLogo();
  }

  /* eslint-disable-next-line react-hooks/rules-of-hooks */
  const { data, isFetched } = usePaymentLinkId(params?.paymentLinkId);

  if (!isFetched) {
    return <Spinner size="small" />;
  }

  const organization =
    data?.account_settings?.organization || Organizations.PAGARME;
  const logoUrl = data?.layout_settings?.image_url;
  const shouldUseBrandLogo = !logoUrl || isLegacyStoneLogo(logoUrl);

  if (shouldUseBrandLogo) {
    return fallbackLogo(organization);
  }

  return <img height="32px" src={logoUrl} alt="Logo" />;
}
